import {
  useSelectMobileNavState,
  useSelectErrorState,
} from '@squareup/dex-store-access-shared-main-selectors';
import { ChildrenProp, NullableClassName } from '@squareup/dex-types-shared-ui';
import { MobileNavShifter } from '@squareup/dex-ui-shared-mobile-nav';
import React, { FC } from 'react';

import { PageErrorHandler } from './PageErrorHandler';

const PageContentsContainer: FC<
  { returnHref: string } & NullableClassName & ChildrenProp
> = ({ children, returnHref }) => {
  const errorState = useSelectErrorState();
  const { isOpen } = useSelectMobileNavState();

  return (
    <MobileNavShifter
      isMobileNavOpen={isOpen}
      render={() => {
        return (
          <PageErrorHandler returnHref={returnHref} error={errorState}>
            {children}
          </PageErrorHandler>
        );
      }}
    ></MobileNavShifter>
  );
};

export { PageContentsContainer };
